"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.replace");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "UploadUi",
  props: {
    accept: {
      type: String,
      default: ".xls,.xlsx"
    }
  },
  data: function data() {
    return {
      name: "",
      fileList: []
    };
  },
  methods: {
    //通过onchanne触发方法获得文件列表
    handleChange: function handleChange(file, fileList) {
      if (this.accept) {
        var str = "/.(" + this.accept.replace(/,/g, "?|") + "?" + ")$/i";
        var fileName = file.name.toLowerCase();
        var name = eval(str).test(fileName);
        if (!name) {
          this.$message({
            dangerouslyUseHTMLString: true,
            message: "支持文件格式：" + "\n" + this.accept,
            type: "warning"
          });
          this.$refs.upfile.clearFiles();
          return false;
        } else {
          this.fileList = fileList;
          this.name = fileList[0].name;
          console.log(file);
          this.$refs.upfile.clearFiles();
        }
      }
      this.$emit("successData", file);
    },
    handleFormatError: function handleFormatError() {
      // 文件格式上传不正确
      this.$message.warning("请使用 .xls ，.xlsx 文件");
    },
    uploadError: function uploadError() {
      this.$message.error("上传失败！");
    },
    beforeUpload: function beforeUpload(file) {
      console.log(file);
      if (this.accept) {
        var str = "/.(" + this.accept.replace(/,/g, "?|") + "?" + ")$/i";
        var fileName = file.name.toLowerCase();
        var name = eval(str).test(fileName);
        if (!name) {
          this.$message({
            dangerouslyUseHTMLString: true,
            message: "支持文件格式：" + "\n" + this.accept,
            type: "warning"
          });
          return false;
        }
      }
    },
    reMoveFiles: function reMoveFiles() {
      this.$refs.upfile.clearFiles();
    }
  }
};